import { autoUpdate, offset, useFloating } from '@floating-ui/react-dom';

export const useSetupFloating = ({ popperElement, referenceElement, placement }) => {
  return useFloating({
    elements: {
      floating: popperElement,
      reference: referenceElement,
    },
    placement: placement || 'bottom',
    strategy: 'fixed',
    // Offset the popper element by -120px to adjust its positioning
    // due to custom design requirements
    middleware: [offset(-120)],
    whileElementsMounted: autoUpdate,
  });
};
